import setup from './moduleSetup';

export default {
    name: 'sagas',
    before: [],
    after: [],
    setup,
};
